import { render } from "./ZoneDetail.vue?vue&type=template&id=0a230af0&scoped=true"
import script from "./ZoneDetail.vue?vue&type=script&lang=js"
export * from "./ZoneDetail.vue?vue&type=script&lang=js"

import "./ZoneDetail.vue?vue&type=style&index=0&id=0a230af0&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20221128.131745/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a230af0"]])

export default __exports__